import { INDICES_VIEW_ALL, INDICES_VIEW_ALL_ERROR, INDICES_VIEW_ALL_HIDE_ERROR, INDICES_VIEW_ALL_START_LOADER, INDICES_VIEW_ALL_STOP_LOADER, INDICES_VIEW_ALL_STREAM, } from "../interface/iIndicesViewAll";
import { indicesViewAllStreamingUpdated, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
const initState = {
    data: {},
    loader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
    updatedtime: "",
};
const indicesViewAll = (state = initState, action) => {
    switch (action.type) {
        case INDICES_VIEW_ALL:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, updatedtime: action.payload.updatedTime });
        case INDICES_VIEW_ALL_STREAM:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data.data), { data: indicesViewAllStreamingUpdated(state.data.data, action.payload.quoteStream), lut: action.payload.quoteStream.updatedTime }), updatedtime: action.payload.quoteStream.updatedTime });
        case INDICES_VIEW_ALL_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case INDICES_VIEW_ALL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case INDICES_VIEW_ALL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case INDICES_VIEW_ALL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default indicesViewAll;
